export function getEnhancedUpfrontFee(issuePrice: number, tradingOffer: number, xMargin: number): number {
  return issuePrice - getEnhancedOfferPrice(tradingOffer, xMargin);
}

export function getEnhancedOfferPrice(tradingOffer: number, xMargin: number): number {
  return tradingOffer + xMargin;
}

export function getEnhancedFixedAmountInPercent(tradingOffer: number, xMargin: number): number {
  return -getEnhancedOfferPrice(tradingOffer, xMargin);
}
